<template>
  <div v-loading="loadingData" class="address-detail f-c">
    <address-detail-stats :address="address" v-if="address" />
    <div class="functions-board">
      <div class="f-r-vc large-basic-info" style="gap: 20px">
        <span class="title">{{ factCode }}</span>
        <span class="title">{{ street }}</span>
        <span class="title">{{ zip }}</span>
      </div>
      <div class="features f-r-vc">
        <el-button type="danger" class="feature-secondary" @click="openDelete">
          <svg-icon icon-class="trash" class="svg-white-color" />
          Delete
        </el-button>
      </div>
    </div>
    <address-info :addressId="addressId" />
    <div class="f-r">
      <div class="tabs">
        <el-tabs v-model="selectedTab" @tab-click="selectTabChange">
          <el-tab-pane
            label="Pallet List"
            :name="PalletListTab"
            v-if="factCode"
          >
            <pallet-list :palletQuery="{ addressId }" />
          </el-tab-pane>
        </el-tabs>
      </div>
      <div class="location-card">
        <div id="map" class="mapbox" />
      </div>
    </div>
    <confirm
      ref="deleteConfirm"
      title="Delete Address"
      :confirmCb="confirmDelete"
      :loading="deleteChecking"
    >
      <template v-slot:content>
        <div class="f-c confirm-delete-hint">
          <span>
            Address is used in <strong>{{ palletsCount }}.</strong> pallets
          </span>
          <span></span>
        </div>
      </template>
    </confirm>
  </div>
</template>
<script>
// mixin
import { pageJumps } from '@/core/mixin/pages'
import { PalletListTab, TabsMixin } from '@/core/mixin/tabs'
// components
import AddressDetailStats from '@/components/address/AddressDetailStats.vue'
import AddressInfo from '@/components/address/AddressInfo.vue'
import PalletList from '@/components/pallet/PalletList.vue'
import Confirm from '@/components/common/Confirm.vue'
// api
import { queryAddress, deleteAddress } from '@/api/address'
import { queryPallets } from '@/api/pallet'
import { mapGetters } from 'vuex'
const mapboxgl = require('mapbox-gl')
export default {
  name: 'AddressDetail',
  mixins: [TabsMixin, pageJumps],
  components: {
    AddressDetailStats,
    AddressInfo,
    PalletList,
    Confirm
  },
  data() {
    return {
      address: null,
      loadingData: false,
      selectedTab: PalletListTab,
      mapbox: null,
      curPosLayerId: 'cur-pos-layer',
      curPosSourceId: 'cur-pos-source',
      deleteChecking: false,
      palletsCount: 0
    }
  },
  computed: {
    addressId() {
      return this.$route.params.id
    },
    street() {
      return this.address?.street ?? ''
    },
    factCode() {
      return this.address?.code ?? ''
    },
    zip() {
      return this.address?.zip ?? ''
    },
    ...mapGetters(['mapboxToken'])
  },
  methods: {
    async detailAddress() {
      this.loadingData = true
      if (this.addressId) {
        const page = await queryAddress({
          addressIds: [this.addressId],
          size: 1
        })
        this.$set(this, 'address', page.records[0])
        this.loadingData = false
        this.showAddressLoc()
      }
    },
    selectTabChange() {},
    showAddressLoc() {
      new mapboxgl.Marker({ color: 'red' })
        .setLngLat([this.address.longitude, this.address.latitude])
        .addTo(this.mapbox)
      this.mapbox.flyTo({
        center: [this.address.longitude, this.address.latitude],
        zoom: 12
      })
    },
    openDelete() {
      this.$refs.deleteConfirm.open()
      this.deleteChecking = true
      queryPallets({ addressId: this.addressId })
        .then(res => {
          this.palletsCount = res.records.length
        })
        .finally(() => {
          this.deleteChecking = false
        })
    },
    confirmDelete(done, error, confirmed = true) {
      deleteAddress(this.addressId)
        .then(() => {
          this.deleteChecking = false
          if (confirmed) {
            done()
            this.goToAddress({ replace: true })
          }
        })
        .catch(err => {
          if (error) {
            error('failed to delete address, ' + err.toString())
          }
        })
    }
  },
  mounted() {
    this.detailAddress()
    mapboxgl.accessToken = this.mapboxToken
    this.mapbox = new mapboxgl.Map({
      container: 'map',
      style: 'mapbox://styles/mapbox/streets-v11',
      interactive: false,
      maxZoom: 18,
      center: [-118.028264, 33.896343]
    })
  }
}
</script>
<style lang="scss" scoped>
@import '@/assets/styles/common.scss';

.functions-board {
  @extend .common-card-margin;
  @extend .f-c;

  gap: 20px;
  justify-content: space-between;

  .el-button {
    border: none;
  }

  .large-basic-info {
    flex-grow: 1;
    gap: 20px;
    padding-top: 30px;
    padding-bottom: 20px;

    .title {
      font-family: 'oswald bold', sans-serif;
      white-space: nowrap;
      padding-left: 3px;
      font-size: 46px;
      line-height: 46px;
      font-weight: bolder;
    }
  }

  .features {
    flex-wrap: wrap;
    gap: 10px;

    .el-button {
      margin-left: 0 !important;
    }
  }
}

.tabs {
  width: 60%;
  border-radius: $home-card-border-radius;
  padding: $home-card-padding-y $home-card-padding-x;
  background-color: white;
  margin-right: 0 !important;

  @extend .global-margin;
  @extend .shadow-level-three;
}

.location-card {
  flex-grow: 1;
  margin-left: 20px;
  margin-right: 20px;
  height: 500px;

  #map {
    border-radius: 5px;
    margin-top: 10px;
    width: 100%;
    height: calc(100% - 10px);
  }
}
</style>
